import { apiCall } from "api-calls/api-call"

export type IMarketplaceCohort = {
  id: string
  name: string
  accountCreatedFrom: string | null
  accountCreatedTo: string | null

  /** Values are strings on the wire; convert to numbers in the UI */
  rules: Record<string, string>
}

export type CreateCohortInput = {
  name: string
  accountCreatedFrom?: string | null
  accountCreatedTo?: string | null
  rules?: Record<string, string>
}

export type UpdateCohortInput = Omit<CreateCohortInput, "name"> & { name?: string }

export const listMarketplaceCohorts = async(): Promise<IMarketplaceCohort[]> => {
  return apiCall({ method: "GET", path: "buff-play/marketplace/cohorts" })
}

export const createMarketplaceCohort = async(body: CreateCohortInput): Promise<IMarketplaceCohort> => {
  return apiCall({ method: "POST", path: "buff-play/marketplace/cohorts", body })
}

export const updateMarketplaceCohort = async(id: string, body: UpdateCohortInput): Promise<IMarketplaceCohort> => {
  return apiCall({ method: "PUT", path: `buff-play/marketplace/cohorts/${id}`, body })
}

export const deleteMarketplaceCohort = async(id: string): Promise<void> => {
  return apiCall({ method: "DELETE", path: `buff-play/marketplace/cohorts/${id}` })
}
